import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Typography } from "@mui/material";

function PlanExpiredBlockedPopup({ open = true }) {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      aria-labelledby="plan-expired-title"
    >
      <DialogContent>
        <Box textAlign="center" py={2}>
          <Typography id="plan-expired-title" variant="h5" fontWeight={700} mb={1}>
            Your Plan has expired
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Please contact your Admin.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default React.memo(PlanExpiredBlockedPopup);
